import * as React from 'react';
import PropTypes from 'prop-types';
import { theme } from '../../theme/theme';
import { ThemeProvider } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import { DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { BOGLE_REGULAR, BOGLE_BOLD } from '../../constants/constant';
const { WHITE, PURPLE, LIGHT_GREY1 } = colors;
import { colors } from '../../theme/color-palette';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
	cancelButton: {
		textTransform: 'none !important',
		borderRadius: '25px !important',
		borderColor: `${LIGHT_GREY1} !important`,
		color: `${PURPLE} !important`,
		paddingTop: '6px !important',
		marginRight: '8px !important',
		fontFamily: 'Bogle-Bold !important',
		boxShadow: 'none !important',
	},
	deleteButton: {
		borderRadius: '25px !important',
		fontSize: '14px !important',
		fontFamily: 'Bogle-Bold !important',
		textTransform: 'none !important',
		color: `${WHITE} !important`,
		backgroundColor: `${PURPLE} !important`,
		boxShadow: 'none !important',
		'&:hover': {
			backgroundColor: `${PURPLE} !important`,
		},
	},
});

export default function ErrorDialog(props) {
	const {
		title,
		description,
		alertCloseHandler,
		option,
		secondaryOption,
		optionClickHandler,
		secondaryOptionClickHandler,
		secondaryDescription,
	} = props;
	const [open, setOpen] = React.useState(true);
	const classes = useStyles();

	const handleClose = () => {
		if (alertCloseHandler) {
			alertCloseHandler(false);
		} else {
			setOpen(false);
		}
	};

	function handleOnClick() {
		if (optionClickHandler) {
			optionClickHandler();
		} else {
			setOpen(false);
		}
	}

	return (
		<ThemeProvider theme={theme}>
			<Dialog
				sx={{
					'& .MuiDialog-paper': {
						borderRadius: '16px',
						minWidth: '600px',
						'@media only screen and (max-width: 780px)': {
							width: '100%',
							minWidth: 'unset !important',
						},
					},
				}}
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				disableEnforceFocus
				aria-describedby="alert-dialog-description">
				<DialogTitle
					id="alert-dialog-title"
					sx={{ fontFamily: BOGLE_BOLD, color: '#000000', fontSize: '24px' }}>
					{title}
				</DialogTitle>
				<DialogContent>
					<DialogContentText
						id="alert-dialog-description"
						sx={{
							color: '#2E2F32',
							fontFamily: BOGLE_REGULAR,
							paddingTop: '30px',
							textAlign: 'left',
							fontSize: '18px',
						}}>
						{description}
					</DialogContentText>
					<div
						id="alert-dialog-secondary-description"
						style={{
							color: '#74767C',
							fontFamily: BOGLE_REGULAR,
							fontSize: '12px',
							paddingBottom: '30px',
							marginTop: '10px',
						}}>
						{secondaryDescription}
					</div>
				</DialogContent>
				<DialogActions
					sx={{
						borderTop: '1px solid #E3E4E5 !important',
						paddingTop: '16px !important',
						paddingBottom: '16px !important',
						paddingRight: '24px !important',
					}}>
					<Button
						variant="outlined"
						className={classes.cancelButton}
						onClick={secondaryOptionClickHandler}>
						{secondaryOption}
					</Button>
					<Button
						variant="outlined"
						className={classes.cancelButton}
						onClick={handleOnClick}>
						{option}
					</Button>
				</DialogActions>
			</Dialog>
		</ThemeProvider>
	);
}

ErrorDialog.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	alertCloseHandler: PropTypes.func,
	option: PropTypes.string,
	secondaryOption: PropTypes.string,
	optionClickHandler: PropTypes.func,
	secondaryOptionClickHandler: PropTypes.func,
	secondaryDescription: PropTypes.string,
};
